import { DropdownButton } from "@biteship/atom";
import { useState } from "react";
import { PHONE_PREFIXES } from "@constants/auth";

export default function PhoneNumberPrefix(props) {
  const [buttonTitle, setButtonTitle] = useState("🇮🇩 +62");
  const prefixOptions = () => {
    return PHONE_PREFIXES.map((i) => ({
      title: i.title,
      onClick: (e) => {
        setButtonTitle(i.title);
        props.onSelectPrefix(i.value);
      },
    }));
  };
  return (
    <DropdownButton
      title={<div className="text-gray-900">{buttonTitle}</div>}
      actions={[prefixOptions()]}
      buttonClassName="items-center border-gray-700 min-w-max"
      menuClassName="w-full max-h-56"
    />
  );
}
